import React, { useEffect, useState, useCallback } from 'react';
import { Breadcrumbs, TextInput, Button } from 'kangarootime-ui';
import { connect } from 'react-redux';
import actions from '../duck/actions';
import NavigationBars from '../../../../components/HOC/withNavigationBars';
import moment from 'moment';
import RangeTimecardsTable from './RangeTimecardsTable';
import '../EmployeeAttendanceToday/EmployeeAttendanceToday.css';

const EmployeeAttendanceRange = ({
  fetchingTimecards,
  timecardsInSelectedRange,
  clockEditsById,
  ...props
}) => {
  const [employee, setEmployee] = useState({ employeeId: '', name: '' });
  const [startDate, setStartDate] = useState(moment());
  const [endDate, setEndDate] = useState(moment());

  // effects
  useEffect(() => {
    if (props.location.state) {
      const { employee } = props.location.state;

      if (employee) {
        setEmployee(employee);
      }
    }
  }, []);
  // end of effects

  const handleSearch = useCallback(() => {
    if (startDate && endDate) {
      props.getTimecardsInRange(employee.employeeId, startDate, endDate);
    }
  }, [startDate, endDate, employee]);

  return (
    <NavigationBars>
      <div className='flex-columns flex-1'>
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Attendance', link: null },
            { label: 'Employee', link: null },
            { label: `${employee.name}`, link: null }
          ]}
        />
        <div className='employee-attendance-container'>
          <div className='flex' style={{ margin: '8px 0', justifyContent: 'flex-end' }}>
            <div style={{ margin: '0 8px' }}>
              <TextInput
                type='date'
                label='Start'
                value={startDate.format('YYYY-MM-DD')}
                onChange={event => setStartDate(moment(event.target.value))}
              />
            </div>
            <TextInput
              type='date'
              label='End'
              value={endDate.format('YYYY-MM-DD')}
              onChange={event => setEndDate(moment(event.target.value))}
            />
            <div className='flex-columns' style={{ justifyContent: 'flex-end' }}>
              <Button
                onClick={handleSearch}
                disabled={moment(startDate).isAfter(moment(endDate))}
              >
                Search
              </Button>
            </div>
            { Object.keys(clockEditsById).length > 0 &&
              <div className='flex-columns' style={{ justifyContent: 'flex-end' }}>
                <Button
                  type='secondary'
                  onClick={props.postTimecardUpdates}
                >
                  Save
                </Button>
              </div>
            }
          </div>
          <RangeTimecardsTable
            fetchingTimecards={fetchingTimecards}
            timecards={timecardsInSelectedRange}
            setEditsToTimecard={props.setEditsToTimecard}
            clockEditsById={clockEditsById}
            postTimecardUpdates={props.postTimecardUpdates}
          />
        </div>
      </div>
    </NavigationBars>
  );
};

// no redux hooks :(
const mapStateToProps = state => {
  return {
    fetchingTimecards: state.attendance.employee.meta.fetchingTimecards,
    timecardsInSelectedRange: state.attendance.employee.range.timecards,
    clockEditsById: state.attendance.employee.range.clockEditsById
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getTimecardsInRange: (employeeId, start, end) => dispatch(actions.getEmployeeTimecardsInRange(employeeId, start, end)),
    setEditsToTimecard: (timecardId, start, end) => dispatch(actions.setEditsToTimecard(timecardId, start, end)),
    postTimecardUpdates: () => dispatch(actions.updateTimecardsRequest())
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeAttendanceRange);
